// extracted by mini-css-extract-plugin
export default {"card":"Card_card__V+7ol","image":"Card_image__b0iFa","text":"Card_text__Z1nYY","btn":"Card_btn__Gg4Bw","container":"Card_container__FO8Ay"};